<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="image"><a id="page_vi"></a><img alt="Image" src="images/f00vi-01.jpg"/></p>
<p class="center-para">Henry Holt and Company, LLC</p>
<p class="center-para"><em>Publishers since 1866</em></p>
<p class="center-para">175 Fifth Avenue</p>
<p class="center-para">New York, New York 10010</p>
<p class="center-para"><a href="http://www.henryholt.com" target="_blank">www.henryholt.com</a></p>
<p class="para"> </p>
<p class="center-para">Henry Holt<sup>®</sup> and <img alt="Image" src="images/f00vi-02.jpg"/><sup>®</sup> are registered trademarks<br/>of Henry Holt and Company, LLC.</p>
<p class="para"> </p>
<p class="center-para">Copyright © 2009 by Paul Auster</p>
<p class="center-para">All rights reserved.</p>
<p class="center-para">Distributed in Canada by H. B. Fenn and Company Ltd.</p>
<p class="para"> </p>
<p class="center-para">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"> </p>
<p class="para">Auster, Paul, 1947–</p>
<p class="indent-para">Invisible / Paul Auster.—1st ed.</p>
<p class="indent-para">       p. cm.</p>
<p class="indent-para">ISBN 978-0-8050-9080-2</p>
<p class="indent-para">1. College students—Fiction. 2. Poets—Fiction. 3. Nineteen sixties—Fiction.<br/>4. Psychological fiction. I. Title.</p>
<p class="indent-para">PS3551.U77158 2009</p>
<p class="indent-para">813'.54—dc22</p>
<p class="right-para">2009002237</p>
<p class="para"> </p>
<p class="center-para">Henry Holt books are available for special promotions<br/>and premiums. For details contact: Director, Special Markets.</p>
<p class="para"> </p>
<p class="center-para">First Edition 2009</p>
<p class="para"> </p>
<p class="center-para">Designed by Victoria Hartman</p>
<p class="para"> </p>
<p class="center-para">Printed in the United States of America</p>
<p class="para"> </p>
<p class="center-para">1 3 5 7 9 10 8 6 4 2</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?4e059ac2